const calculateAgents = (): string =>
  // const start = new Date("1-21-2021");
  // const today = new Date();
  // const difference = today.valueOf() - start.valueOf();
  // const differenceDays = difference / (1000 * 60 * 60 * 24);
  // const floored = Math.floor(differenceDays * 3) + 26028;

  // const arr = Array.from(floored.toString());
  // arr.splice(arr.length - 3, 0, " ");
  // return arr.join("");
  "28 509";
export default calculateAgents;
